import { PATHS } from '@belong/common';

export const getLoginUrl = (backTo: string) => {
  const loginURL = new URL(PATHS.AUTH_LOGIN, window.location.origin);
  loginURL.searchParams.set('backTo', backTo);

  return loginURL.toString();
};
